import { tr } from "./utils/localeManager";

export const kPluginMidWidth = 328;
export const kPluginName = tr("DG.Plugin.Sampler.title");
export const kVersion = "v1.0.4";
export const kInitialDimensions = {
  width: kPluginMidWidth,
  height: 550
};
